import { mockCmsIcon } from '@domgen/dgx-fe-cms';
import { mockNavigationLink } from '@domgen/dgx-fe-common';
import { ContactUsPanel } from '../../models/contact-us/contact-us-panel.model';

export const mockContactUsPanel: ContactUsPanel = {
  body: 'body',
  icon: mockCmsIcon,
  link: mockNavigationLink,
  title: 'title',
};
